export default function About() {
  return (
    <section className="about section" id="about">
      <div className="container">
        <div className="row">
          <div className="section-title padd-15">
            <h2>About</h2>
          </div>
        </div>
        <div className="row">
          <div className="about-content padd-15">
            <div className="row">
              <div className="about-text padd-15">
                <h3>
                  My name is Sazid and I <span>...</span>
                </h3>
                <p>
                  was Born 2000 in Chandpur, Bangladesh . In 2022 I finished my
                  studying in Bangladesh Skill Development Institute, Chandpur
                  where I learned some coding and a lot of design skills, but I
                  definitely felt in love with 3D, graphic design , vfx and
                  motion design. <br />
                  <br />
                  Since then all my concentration and power went into my passion
                  to become better and better and to realize my imaginations.
                  Now I am working as a 3D Animator at animaster studio company.
                  Now i also keep learning new thing about 3d animation , motion
                  graphic and vfx.
                </p>
              </div>
            </div>
            <div className="row">
              <div className="personal-info padd-15">
                <div className="row">
                  <div className="info-item padd-15">
                    <p>
                      Age : <span>26</span>
                    </p>
                  </div>

                  <div className="info-item padd-15">
                    <p>
                      Email : <span>sazidmostafiz2019@gmail.com</span>
                    </p>
                  </div>
                  <div className="info-item padd-15">
                    <p>
                      Education : <span>Diploma in CSE</span>
                    </p>
                  </div>
                  <div className="info-item padd-15">
                    <p>
                      Phone : <span>+8801814264333 </span>
                    </p>
                  </div>
                  <div className="info-item padd-15">
                    <p>
                      City : <span>Dhaka, Bangladesh</span>
                    </p>
                  </div>
                  <div className="info-item padd-15">
                    <p>
                      Freelance : <span>Available</span>
                    </p>
                  </div>
                  <div>
                <a href="https://firebasestorage.googleapis.com/v0/b/sazid-mostafiz-portfolio.firebasestorage.app/o/portfolio_pdf%2FCV%20of%20Sazid%20Mostafiz.pdf?alt=media&token=3b47429e-5a6f-4ef0-a848-ff4986088705" className="btn hire-me" style={{marginLeft: "15px", marginTop:"25px"}}>
                Download Resume</a>
              </div>
                </div>
              </div>
              
              <div className="skills padd-15">
                <div className="row">
                  <div className="skill-item padd-15">
                    <h5>Blender</h5>
                    <div className="progress">
                      <div className="progress-in" style={{width: "95%"}}></div>
                      <div className="skill-percent">95%</div>
                    </div>
                  </div>
                  <div className="skill-item padd-15">
                    <h5>Maya</h5>
                    <div className="progress">
                      <div className="progress-in" style={{width: "80%"}}></div>
                      <div className="skill-percent">80%</div>
                    </div>
                  </div>
                  <div className="skill-item padd-15">
                    <h5>After Effect</h5>
                    <div className="progress">
                      <div className="progress-in" style={{width: "90%"}}></div>
                      <div className="skill-percent">90%</div>
                    </div>
                  </div>
                  <div className="skill-item padd-15">
                    <h5>Photoshop</h5>
                    <div className="progress">
                      <div className="progress-in" style={{width: "90%"}}></div>
                      <div className="skill-percent">90%</div>
                    </div>
                  </div>
                  <div className="skill-item padd-15">
                    <h5>Illiustrator</h5>
                    <div className="progress">
                      <div className="progress-in" style={{width: "85%"}}></div>
                      <div className="skill-percent">85%</div>
                    </div>
                  </div>
                  <div className="skill-item padd-15">
                    <h5>Premier Pro</h5>
                    <div className="progress">
                      <div className="progress-in" style={{width: "85%"}}></div>
                      <div className="skill-percent">85%</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="education padd-15">
                <h3 className="title">Education</h3>
                <div className="row">
                  <div className="timeline-box padd-15">
                    <div className="timeline shadow-dark">
                      <div className="timeline-item">
                        <div className="circle-dot"></div>
                        <h3 className="timeline-date">
                          <em className="fa fa-calendar"></em> 2018 - 2022
                        </h3>
                        <h4 className="timeline-title">Diploma</h4>
                        <p className="timeline-text">Diploma in CSE</p>
                      </div>
                      <div className="timeline-item">
                        <div className="circle-dot"></div>
                        <h3 className="timeline-date">
                          <em className="fa fa-calendar"></em> 2016 - 2017
                        </h3>
                        <h4 className="timeline-title">HSC</h4>
                        <p className="timeline-text">Business management</p>
                      </div>
                      <div className="timeline-item">
                        <div className="circle-dot"></div>
                        <h3 className="timeline-date">
                          <em className="fa fa-calendar"></em> 2014 - 2015
                        </h3>
                        <h4 className="timeline-title">SSC</h4>
                        <p className="timeline-text">Business Study</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="experience padd-15">
                <h3 className="title">Experience</h3>
                <div className="row">
                  <div className="timeline-box padd-15">
                    <div className="timeline shadow-dark">
                      <div className="timeline-item">
                        <div className="circle-dot"></div>
                        <h3 className="timeline-date">
                          <em className="fa fa-calendar"></em> 2024-June, 2025
                        </h3>
                        <h4 className="timeline-title">
                          3D Animator: Animaster Studio
                        </h4>
                        <p className="timeline-text">
                          Joined Animaster Studio as full time employee working
                          as a 3D Animator and Motion Graphics Designer
                        </p>
                      </div>
                      <div className="timeline-item">
                        <div className="circle-dot"></div>
                        <h3 className="timeline-date">
                          <em className="fa fa-calendar"></em> 2023-2024
                        </h3>
                        <h4 className="timeline-title">3D Artist Intern</h4>
                        <p className="timeline-text">
                          Worked as an intern for Animaster Studio
                        </p>
                      </div>
                      <div className="timeline-item">
                        <div className="circle-dot"></div>
                        <h3 className="timeline-date">
                          <em className="fa fa-calendar"></em> 2024
                        </h3>
                        <h4 className="timeline-title">Motion Graphic Designer</h4>
                        <p className="timeline-text">Motion Graphic course</p>
                      </div>
                      <div className="timeline-item">
                        <div className="circle-dot"></div>
                        <h3 className="timeline-date">
                          <em className="fa fa-calendar"></em> 2023
                        </h3>
                        <h4 className="timeline-title">3D Animator</h4>
                        <p className="timeline-text">3d animation course</p>
                      </div>
                      <div className="timeline-item">
                        <div className="circle-dot"></div>
                        <h3 className="timeline-date">
                          <em className="fa fa-calendar"></em> 2018
                        </h3>
                        <h4 className="timeline-title">Graphic Designer</h4>
                        <p className="timeline-text">Graphic Design course</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
